// =============================================================================
// BinTipSource — the "Bin RBN-… · from pallet KF49-… · 20 ctns" line under a
// bin-sourced tip on a run's tip log.
//
// Before mig 20261019090000 a retipped RECEIVED pallet rendered as
// "Tip 3 · 1 bin · 550 kg net" with nothing to find it by: the pallet id
// lived only in bins.notes text. Both run-detail surfaces render this line
// the same way (Runs.tsx inline detail at 11px, RunDetail.tsx print view at
// 10px); the size and whether the pallet is a link are the only differences.
// Renders nothing when the tip is not bin-sourced.
// =============================================================================
import { Link } from 'react-router-dom'
import type { BinTipSourceFacts } from '@/lib/tipSource'

export function BinTipSource({ facts, compact = false, link = true }: {
  facts: BinTipSourceFacts
  /** Print-view sizing (10px, tight). Default is the inline-detail 11px. */
  compact?: boolean
  /** Render the pallet id as a link to its page. Off on print surfaces. */
  link?: boolean
}) {
  if (!facts.bin_number) return null
  const pallet = facts.source_pallet_id
  const ctns = facts.source_carton_count
  return (
    <p className={compact ? 'text-[10px] text-fg-muted mt-0.5' : 'text-[11px] text-fg-muted mt-1'}>
      Bin <span className="text-cyan-300 font-mono">{facts.bin_number}</span>
      {pallet && (
        <span className="text-muted">
          {' · '}from pallet{' '}
          {link
            ? <Link to={`/pallets/${pallet}`}
                className="text-cyan-300 font-mono underline decoration-gray-600 underline-offset-2 hover:text-cyan-200">
                {pallet}
              </Link>
            : <span className="text-cyan-300 font-mono">{pallet}</span>}
        </span>
      )}
      {ctns != null && (
        <span className="text-muted">{' · '}{ctns} ctn{ctns === 1 ? '' : 's'}</span>
      )}
    </p>
  )
}
